import { useState } from "react"

export default function ExemptionCheckbox({ element, index, defaultChecked, onExemptionChange }) {
	const [showDescription, setShowDescription] = useState(defaultChecked)
	let id = `exemption|${element.exemption_id}`

	function handleChecked(e) {
		onExemptionChange(e)
		setShowDescription(prevState => !prevState)

	}
	
	return (
		<li key={index} className="">
			<div className="form-check">
				<input
					type="checkbox"
					id={id}
					name="ExemptionsList"
					onChange={handleChecked}
					title={element.exemption_label}
					defaultChecked={defaultChecked}
					value={index}
					alwayshidden="false"
					className="form-check-input"
				/>
				<label htmlFor={id} className="form-check-text">
					{element.exemption_label}
				</label>
			</div>
			<div
				id={index}
				className={`px-3 py-1 mb-3 border rounded ${showDescription ? "d-block" : "d-none"}`}
				style={{maxWidth: "650px"}}
			>
				<p className="fw-bold mb-0">
					Key Requirements:
				</p>
				<ul className="">
					{
						element.requirements.map((requirement, reqIndex) => {
							let reqKey = `${index}-${reqIndex}`

							return (
								<li key={reqKey} dangerouslySetInnerHTML={{ __html: requirement.requirement_label }} />
							)
						})
					}
				</ul>
			</div>
		</li>
	)
}